import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';

import { TariffProfilesEntityGrid } from '../features/tariff-profile/tariff-profiles-entity-grid/tariff-profiles-entity-grid';

export const AllTariffProfilesPage = observer(() => {
  return (
    <AppPage perm="PERM_TARIFF_PROFILE_READ" noWrapper>
      <TariffProfilesEntityGrid />
    </AppPage>
  );
});
